import { VbzRadio } from '@smiles/voebiz-ui-kit';
import React from 'react';

type VbzRadioGroupT = {
  name: string;
  onChange: () => void;
  value: string;
  title: string;
};

export default function VbzRadioGroup(props: VbzRadioGroupT) {
  return (
    <div className="vbz_radio_group_container">
      <legend>{props.title}</legend>
      <div className="vbz_radio_group_wrapper">
        <VbzRadio
          id={`${props.name}Positive`}
          name={props.name}
          label="Sim"
          value="Y"
          onChange={props.onChange}
          checked={props.value === 'Y'}
        />
        <VbzRadio
          id={`${props.name}Negative`}
          name={props.name}
          label="Não"
          value="N"
          onChange={props.onChange}
          checked={props.value === 'N'}
        />
      </div>
    </div>
  );
}
